<div>
  <p>
    <span>
      <strong>
        {{ 'plugins.installationexecutivesummary.description' | translate }}
      </strong>
    </span>
  </p>
  <p style="margin-top: 20px" *ngIf="config?.Value">
    <span innerHtml="{{ config?.Value }}"></span>
  </p>
</div>
